<template>
  <div>
    <LinkTitle></LinkTitle>
    <div class="conatainer">
      <PageSearchTitle
        title="白条售后服务规范"
        hideSearch="true"
        :showCart="false"
      />
      <div class="box">
        <div class="tabsBox">
          <h2 class="title">肉联所白条售后服务规范</h2>
          <div class='titleHeader'>
            鉴于白条产品是肉链掌柜肉类交易市场的核心产品且属于流通周期非常短暂的快消品，产品质量和售后服务直接关系到平台、卖家声誉并会严重影响买家体验感的敏感性，特制定如下售后服务服务规范。
          </div>
          <h5>一、售后服务响应时间</h5>
          <p>
            1. 产品质量问题（包含不限于脓包、米猪肉、油猪等）卖家必须在收到买家售后申请的2小时内给与回复
          </p>
          <h5>二、售后举证</h5>
          <p>
            1. 买家提供证据确凿（清晰照片、小视频等）之后2小时内给与买家解决方案
          </p>
          <h5>三、损失赔付</h5>
          <p>1. 买卖双方协商一致的，买卖双方自行线下处理</p>
          <h5>四、平台接入</h5>
          <p>
            1. 买家举证确认为质量问题的售后申请卖家不能和买家达成处理一致的情况下，平台有权依据“卖家保证金加入协议”向买家先行赔付，赔付金额直接从卖家缴纳的保证金中扣取。
          </p>
          
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import PageSearchTitle from "@/components/components/PageSearchTitle";

export default {
  name: "supplyPage",
  data() {
    return {};
  },
  components: {
    PageSearchTitle,
  },
  methods: {},
};
</script>

<style scoped lang='less'>
@media screen and(min-width:320px) and(max-width:1200px) {
  .conatainer {
    margin: 5px 10px 0 !important;
  }
}
.conatainer {
  margin: 5px 300px 0;
}
.box {
  margin-top: 20px;
  min-height: 300px;
 
}
.tabsBox {
}
.title{
    padding-top: 20px;
    margin-bottom: 40px;
}
h5{
    margin-top: 15px;
    margin-bottom: 15px;
}
p{
    text-indent: 35px;
     color:#545454;
     font-size: 13px;
}
.titleHeader{
    text-indent: 35px;
     color:#545454;
     font-size: 13px;
}
</style>


// WEBPACK FOOTER //
// src/components/agreement/ServiceAgreement.vue